module.exports = __webpack_public_path__ + "static/map.60c1c0fb.svg";